import _defineProperty from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import { getSecondaryRangeChannel } from '../../channel';
import { hasBand, vgField } from '../../channeldef';
import { getTimeUnitParts, normalizeTimeUnit } from '../../timeunit';
import { duplicate, hash as _hash, keys, vals } from '../../util';
import { isUnitModel } from '../model';
import { DataFlowNode } from './dataflow';
export var TimeUnitNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(TimeUnitNode, _DataFlowNode);

  function TimeUnitNode(parent, formula) {
    var _this;

    _classCallCheck(this, TimeUnitNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeUnitNode).call(this, parent));
    _this.formula = formula;
    return _this;
  }

  _createClass(TimeUnitNode, [{
    key: "clone",
    value: function clone() {
      return new TimeUnitNode(null, duplicate(this.formula));
    }
  }, {
    key: "merge",

    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */
    value: function merge(other) {
      this.formula = Object.assign({}, this.formula); // if the same hash happen twice, merge "band"

      for (var key in other.formula) {
        if (!this.formula[key] || other.formula[key].band) {
          // copy if it's not a duplicate or if we need to include copy band over
          this.formula[key] = other.formula[key];
        }
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = other.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      other.remove();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.as;
      }));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "TimeUnit ".concat(_hash(this.formula));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var transforms = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = vals(this.formula)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var f = _step2.value;
          var field = f.field,
              as = f.as,
              timeUnit = f.timeUnit;

          var _a = normalizeTimeUnit(timeUnit),
              unit = _a.unit,
              utc = _a.utc,
              params = __rest(_a, ["unit", "utc"]);

          transforms.push(Object.assign(Object.assign(Object.assign(Object.assign({
            field: field,
            type: 'timeunit'
          }, unit ? {
            units: getTimeUnitParts(unit)
          } : {}), utc ? {
            timezone: 'utc'
          } : {}), params), {
            as: [as, "".concat(as, "_end")]
          }));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return transforms;
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var formula = model.reduceFieldDef(function (timeUnitComponent, fieldDef, channel) {
        var field = fieldDef.field,
            timeUnit = fieldDef.timeUnit;
        var channelDef2 = isUnitModel(model) ? model.encoding[getSecondaryRangeChannel(channel)] : undefined;
        var band = isUnitModel(model) && hasBand(channel, fieldDef, channelDef2, model.stack, model.markDef, model.config);

        if (timeUnit) {
          var as = vgField(fieldDef, {
            forAs: true
          });
          timeUnitComponent[_hash({
            as: as,
            field: field,
            timeUnit: timeUnit
          })] = Object.assign({
            as: as,
            field: field,
            timeUnit: timeUnit
          }, band ? {
            band: true
          } : {});
        }

        return timeUnitComponent;
      }, {});

      if (keys(formula).length === 0) {
        return null;
      }

      return new TimeUnitNode(parent, formula);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var _a = Object.assign({}, t),
          timeUnit = _a.timeUnit,
          other = __rest(_a, ["timeUnit"]);

      var normalizedTimeUnit = normalizeTimeUnit(timeUnit);
      var component = Object.assign(Object.assign({}, other), {
        timeUnit: normalizedTimeUnit
      });
      return new TimeUnitNode(parent, _defineProperty({}, _hash(component), component));
    }
  }]);

  return TimeUnitNode;
}(DataFlowNode);